import { withStyles } from "@material-ui/core";
import styles from "./styles";
import reportConstants from "../../constants";
import PopupFieldRenderer from "./common/PopupFieldRenderer";
import constants from "./constants";

const getDelayStopLabelByType = (stopType) => {
  const { FUELBREAK, LUNCHBREAK, RESTBREAK } = reportConstants.DISPATCH_STOP_TYPES;
  const stop_label_mapping = {
    [FUELBREAK]: constants.POPUP_LABELS.FUEL_BREAK,
    [LUNCHBREAK]: constants.POPUP_LABELS.LUNCH_BREAK,
    [RESTBREAK]: constants.POPUP_LABELS.REST_BREAK
  };
  return stop_label_mapping[stopType] ?? '';
}
const DelayStopPopup = ({ task, classes }) => {
  return (
    <div className={classes.popupContainer}>
      <PopupFieldRenderer
        label={getDelayStopLabelByType(task.data.stopType)}
        value={`${task.arrivalTime} - ${task.departureTime}`}
        valueClassName={classes.headerRowValue}
      />
    </div>
  );
};

export default withStyles(styles)(DelayStopPopup);
